import React from "react";
import Logo_Constructora from "../../../assets/logo-constructora-white.svg";
import Logo_Proyecto from "../../../assets/logo_proyecto-white.svg";

const PropertyType = require("../../../data/property.type.data");

interface Props {
  propertyType: any;
  setPropertyType: (value: any) => void;
}

const BottombarProperty: React.FC<Props> = ({ propertyType, setPropertyType }) => {

  return (
    <div className="bottombar-menu-property">
      <div className="bottombar-property-content">

        <div className={`bottombar-info-container-logos`}>
          <img className={`bottombar-info-logo`} src={Logo_Constructora} draggable={false} alt=''/>
          <img className={`bottombar-info-logo margin`} src={Logo_Proyecto} draggable={false} alt=''/>
        </div>
        <div className={`bottombar-info-options`}>
          <div className={`bottombar-info-property-text`}>TIPO DE INMUEBLE</div>
          <div className={`bottombar-property-options`}>
            {
              PropertyType.Data.map((property_type: any, index: number) => (
                <div className={`bottombar-info-property-type ${propertyType.id === property_type.id ? 'selected':''}`} onClick={()=>setPropertyType(property_type)}>
                  <div className={`bottombar-info-property-type-text ${propertyType.id === property_type.id ? 'selected':''}`}>{property_type.name}</div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottombarProperty;